import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { Menu, MenuProps } from '@bettercomp/ui-components';
import { useNavigationConfig } from './navigationConfig';
import cn from './styles.module.scss';

type NavMenuProps = {
  mode?: MenuProps['mode'];
  onClick?: () => void;
  className?: string;
}

export const NavMenu = ({ mode = 'horizontal', onClick, className }: NavMenuProps) => {
  const router = useRouter();
  const [selectedKeys, setSelectedKeys] = useState<string[]>([]);

  const navigationConfig = useNavigationConfig();

  useEffect(() => {
    navigationConfig.forEach((item: any) => {
      if (item.children) {
        item.children.forEach((child: any) => {
          if (router.pathname === child.key) {
            setSelectedKeys([item.key, child.key]);
          }
        })
      } else {
        if (router.pathname === item.key) {
          setSelectedKeys([item.key]);
        }
      }

    });
  }, [navigationConfig, router]);

  const navigate = (item: any) => {
    if (item.key) {
      router.push(item.key);
    }
    if (onClick) {
      onClick();
    }
  };

  return (
    <div className={className} data-testid="navMenu">
      <Menu
        classNames={{
          root: cn.root,
          item: cn.item,
        }}
        mode={mode}
        selectedKeys={selectedKeys}
        onClick={navigate}
        items={navigationConfig}
      />
    </div>
  );
};
